'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AlarmApi = require('./api/AlarmApi');

var _AlarmApi2 = _interopRequireDefault(_AlarmApi);

var _EventGroups = require('./constants/EventGroups');

var _EventGroups2 = _interopRequireDefault(_EventGroups);

var _Severity = require('./constants/Severity');

var _Severity2 = _interopRequireDefault(_Severity);

var _Alarm = require('./model/Alarm');

var _Alarm2 = _interopRequireDefault(_Alarm);

var _AlarmContainer = require('./model/AlarmContainer');

var _AlarmContainer2 = _interopRequireDefault(_AlarmContainer);

var _EventData = require('./model/EventData');

var _EventData2 = _interopRequireDefault(_EventData);

var _Debug = require('./util/Debug');

var _Debug2 = _interopRequireDefault(_Debug);

var _Dom = require('./util/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Env = require('./util/Env');

var _Events = require('./util/Events');

var _Events2 = _interopRequireDefault(_Events);

var _CustomEvent = require('./util/CustomEvent');

var _Objects = require('./util/Objects');

var _Storage = require('./util/Storage');

var _Storage2 = _interopRequireDefault(_Storage);

var _StyleSheet = require('./view/StyleSheet');

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _Selenium = require('./util/Selenium');

var _Selenium2 = _interopRequireDefault(_Selenium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CUSTOM_CONTAINER_CLASS = 'fire-alarm-custom-container';
var HUBSPOT_FIREALARM_KEY = 'fireAlarm';
var INCLUDE_BENDER_DOC_LINK = 'https://git.hubteam.com/HubSpot/FireAlarmUi/blob/master/README.md#including-benderprojectdepandpathvariables';
var NAV_V4_ID = 'hs-nav-v4';
var SHOW_DEBUG_ALARMS_KEY = 'firealarm.show.debug.alarms';

var FireAlarmApp = function () {

  /*
   * @param Object hubspot        window.hubspot object
   * @param Object originalConfig (optional) Config object with the following keys:
   *   {
   *     appName:    String (optional) if this is empty appName is taken from bender.
   *     containers: {
   *       default: {
   *         after:              HTMLElement (optional) element in the parent to insert before
   *         additionalClasses:  CSS classes to add to the container
   *         parent:             HTMLElement The element to add the alarm container to,
   *         before:             HTMLElement (optional) element in the parent to insert before
   *       },
   *       critsit: (optional) An over-ride for Crisit Alarms. Same footprint as the default
   *                container
   *     }
   *   }
   */
  function FireAlarmApp(hubspot) {
    var originalConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FireAlarmApp);

    this.className = 'FireAlarmApp';
    this.hubspot = hubspot;
    this.events = new _Events2.default();

    this.events.extractPreloadEvents(hubspot[HUBSPOT_FIREALARM_KEY] || {});

    this.alarms = [];
    try {
      var localStorage = window && window.localStorage ? window.localStorage : false;
      this.storage = new _Storage2.default(localStorage);
    } catch (e) {
      this.storage = new _Storage2.default(false);
    }
    this.events.runEvents(_EventGroups2.default.ON_LOAD);

    this.config = (0, _Objects.defaults)(originalConfig, { containers: {} });
    hubspot[HUBSPOT_FIREALARM_KEY] = this;
  }

  /**
   * @param Object config   App Config, same as gets passed to the constructor
   * @return AlarmContainer Returns a container built from config.containers.critsit where the config is set,
   *                        otherwise it falls back to using the supplied container, if that container was
   *                        built from custom config (config.containers.default). Finally, if no container config
   *                        was passed, it creates a new critsit container.
   */


  _createClass(FireAlarmApp, [{
    key: 'selectOrMakeCritsitContainer',
    value: function selectOrMakeCritsitContainer(config, container) {
      if (config.containers.critsit) {
        var critsitConfig = config.containers.critsit;
        critsitConfig.additionalClasses = critsitConfig.additionalClasses || [];
        critsitConfig.additionalClasses.push('firealarm-critsits');

        return this.makeContainer(critsitConfig);
      } else if (config.containers.default) {
        return container;
      } else {
        return this.makeNavContainer(true);
      }
    }
  }, {
    key: 'addCss',
    value: function addCss() {
      var headElement = document.getElementsByTagName("head")[0];
      if (headElement) {
        var styleEl = _StyleSheet2.default.getCss();
        headElement.appendChild(styleEl);
      }
    }

    /**
     * @VisibleForTesting
     */

  }, {
    key: 'getAlarmApi',
    value: function getAlarmApi() {
      return new _AlarmApi2.default(this.getDom(), this.storage, this.events);
    }

    /**
     * @VisibleForTesting
     */

  }, {
    key: 'getDom',
    value: function getDom() {
      if (!this.dom) {
        this.dom = new _Dom2.default(document);
      }
      return this.dom;
    }
  }, {
    key: 'getNav',
    value: function getNav() {
      if (!this.navElement) {
        var navElement = this.getDom().getElementById(NAV_V4_ID);
        // If we can't find an element with the nav id just chuck the alarms at the top of the page.
        if (!navElement) {
          navElement = this.getDom().getBody().firstChild;
          // Find the first non-text node
          while (navElement != null && navElement.nodeType == 3) {
            navElement = navElement.nextSibling;
          }
        }

        if (!navElement) {
          throw "No Nav element could be found to add FireAlarms";
        }

        this.navElement = navElement;
      }

      return this.navElement;
    }

    /**
     * Get Alarms for this app
     */

  }, {
    key: 'loadAndRenderAppAlarms',
    value: function loadAndRenderAppAlarms(appName) {
      var _this = this;

      var addCss = this.addCss,
          hubspot = this.hubspot;


      this.getAlarmApi().getAlarms(appName, function (newAlarms, apiError) {
        if (apiError) {
          (0, _Debug2.default)('ApiError', apiError.getMessage(), apiError);
        } else {
          (0, _Debug2.default)('Loaded alarms from FireAlarmApi', newAlarms);
          _this.events.runEvents(_EventGroups2.default.ON_RECEIVE_ALARM, new _EventData2.default(newAlarms));

          // Is this QA? Do we have hubspot.bender.currentProject? If not show a FireAlarm warning the dev.
          if ((0, _Env.isQa)() && (!hubspot.bender || !hubspot.bender.currentProject)) {
            newAlarms.push(_this.getBenderWarningAlarm());
          }

          if (newAlarms.length > 0) {
            if (_this.alarms == 0) {
              //Check to make sure the CSS isn't added a second time due to an addAlarm call
              addCss();
            }
            _this.alarms = newAlarms;
            _this.renderAlarms();
          }
        }
      });
    }
  }, {
    key: 'renderAlarms',
    value: function renderAlarms() {
      var _this2 = this;

      var alarms = this.prioritiseAlarms(this.filterAlarms(this.alarms));
      this.containers.default.removeAllAlarms();
      this.containers.critsit.removeAllAlarms();
      alarms.forEach(function (alarm) {
        if (alarm.severity === _Severity2.default.CRITSIT) {
          _this2.containers.critsit.addAlarm(alarm);
        } else {
          _this2.containers.default.addAlarm(alarm);
        }
      });
      this.renderContainers();
      alarms.forEach(function (alarm) {
        _this2.events.runEvents(_EventGroups2.default.ON_RENDER_ALARM, alarm);
      });
      this.events.runEvents(_EventGroups2.default.ON_RENDER_ALL, new _EventData2.default(alarms));
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      if (!this.hubspot || !this.hubspot.bender || !this.hubspot.bender.currentProject) {
        return null;
      }

      return this.hubspot.bender.currentProject;
    }
  }, {
    key: 'makeContainer',
    value: function makeContainer(config) {
      var additionalClasses = (config.additionalClasses || []).concat([DEFAULT_CUSTOM_CONTAINER_CLASS]);
      var mergedConfig = (0, _Objects.objectAssign)({ additionalClasses: additionalClasses }, config);
      return new _AlarmContainer2.default(mergedConfig);
    }
  }, {
    key: 'makeNavContainer',
    value: function makeNavContainer() {
      var critsit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var dom = this.getDom();
      var body = dom.getBody();
      var nav = this.getNav();

      var config = void 0;

      if (critsit) {
        config = {
          parent: body,
          before: nav,
          additionalClasses: ['firealarm-critsits']
        };
      } else {
        config = {
          parent: body,
          after: nav
        };
      }

      return new _AlarmContainer2.default(config);
    }

    /**
     * Get the QA warning message asking devs to install benderProjectDepAndPathVariables
     */

  }, {
    key: 'getBenderWarningAlarm',
    value: function getBenderWarningAlarm() {
      return new _Alarm2.default({
        title: 'FireAlarm needs some setup!',
        message: 'Please include \'benderProjectDepAndPathVariables\' in this app to report it to FireAlarm. See the <a href="' + INCLUDE_BENDER_DOC_LINK + '">FireAlarm docs</a> for more information.',
        createdAt: Date.now(),
        severity: _Severity2.default.MAINTENANCE.key
      }, this.getDom(), this.storage);
    }
  }, {
    key: 'filterAlarms',
    value: function filterAlarms(alarms) {
      if (this.storage.getItem(SHOW_DEBUG_ALARMS_KEY) === 'true') {
        return alarms;
      }
      return alarms.filter(function (alarm) {
        var regEx = new RegExp(alarm.urlRegexPattern);
        return !alarm.debug && alarm.urlRegexPattern ? regEx.test(window.location.href) : true;
      });
    }

    /**
     * Returns alarms sorted by priority, highest to lowest
     *
     * @return array
     */

  }, {
    key: 'prioritiseAlarms',
    value: function prioritiseAlarms(alarms) {
      return alarms.sort(function (a, b) {
        if (a.severity === b.severity) {
          return 0;
        }
        return a.severity.priority < b.severity.priority ? 1 : -1;
      });
    }

    // This is used by FireAlarmClient to create frontend alarms

  }, {
    key: 'addAlarm',
    value: function addAlarm(alarmData) {
      var alarm = new _Alarm2.default(alarmData, this.getDom(), this.storage, this.events, alarmData.date);
      if (this.alarms.length == 0) {
        this.addCss();
      }

      this.alarms.push(alarm);

      if (alarm.severity === _Severity2.default.CRITSIT) {
        this.containers.critsit.addAlarm(alarm);
      } else {
        this.containers.default.addAlarm(alarm);
      }

      this.renderContainers();

      this.events.runEvents(_EventGroups2.default.ON_RENDER_ALARM, alarm);
    }
  }, {
    key: 'renderContainers',
    value: function renderContainers() {
      if (!(0, _Selenium2.default)(this.storage)) {
        if (this.containers.default.alarmElements.length > 0) {
          this.containers.default.render();
        }

        if (this.containers.default !== this.containers.critsit && this.containers.critsit.alarmElements.length > 0) {
          this.containers.critsit.render();
        }
      }
    }
  }, {
    key: 'addLocationChangeEvent',
    value: function addLocationChangeEvent() {
      var _this3 = this;

      //
      // Warning: Modifying global history object
      //
      history.pushState = function (f) {
        return function pushState() {
          var ret = f.apply(this, arguments);
          (0, _CustomEvent.triggerEvent)('fireAlarmLocationChange');
          return ret;
        };
      }(history.pushState);

      history.replaceState = function (f) {
        return function replaceState() {
          var ret = f.apply(this, arguments);
          (0, _CustomEvent.triggerEvent)('fireAlarmLocationChange');
          return ret;
        };
      }(history.replaceState);

      window.addEventListener('popstate', function () {
        (0, _CustomEvent.triggerEvent)('fireAlarmLocationChange');
      });

      window.addEventListener('fireAlarmLocationChange', function () {
        (0, _Debug2.default)('Refiltering fire alarms for this page');
        _this3.renderAlarms();
      });
    }
  }, {
    key: 'start',
    value: function start() {
      (0, _Debug2.default)('FireAlarm started');

      var appName = this.config.appName || this.getAppName();

      var containerConfig = this.config.containers.default || false;
      var container = containerConfig ? this.makeContainer(containerConfig) : this.makeNavContainer();

      var critsitContainer = this.selectOrMakeCritsitContainer(this.config, container);

      this.containers = {
        default: container,
        critsit: critsitContainer
      };

      this.loadAndRenderAppAlarms(appName);
      this.addLocationChangeEvent();
      this.events.runEvents(_EventGroups2.default.CREATE_ALARM, this);
    }
  }]);

  return FireAlarmApp;
}();

FireAlarmApp['HUBSPOT_FIREALARM_KEY'] = HUBSPOT_FIREALARM_KEY;

exports.default = FireAlarmApp;
module.exports = exports['default'];